import * as React from 'react'
import { VyneRadio } from '@vynedental/design-system'
import { RadioChangeEvent } from 'antd'

import './WidgetButtonStyle.sass'

export type WidgetButtonStyleProps = {
    customValue?: Api.widgetButtonStyle | boolean
    updateWidgetButtonStyle: (widgetButtonStyle: Api.widgetButtonStyle) => void
}

const moduleName = 'widget-button-style'

const WidgetButtonStyle = (props: WidgetButtonStyleProps) => {
    const updateWidgetButtonStyle = (e: RadioChangeEvent) => {
        props.updateWidgetButtonStyle(e.target.value as Api.widgetButtonStyle)
    }

    const { customValue } = props
    const radioValue = customValue || 'default'

    return (
        <div className={moduleName}>
            <div className={`${moduleName}__title`}>Style:</div>
            <div className={`${moduleName}__radio-wrapper`}>
                <VyneRadio
                    dataTestId="widget-button-style-default"
                    checked={radioValue === 'default'}
                    onChange={updateWidgetButtonStyle}
                    name="radio-widget-button-style"
                    value="default"
                    isStandalone
                    style={{ marginBottom: 0 }}
                >
                    Default
                </VyneRadio>
            </div>
            <div className={`${moduleName}__radio-wrapper`}>
                <VyneRadio
                    dataTestId="widget-button-style-client-button"
                    checked={radioValue === 'client_button'}
                    onChange={updateWidgetButtonStyle}
                    name="radio-widget-button-style"
                    value="client_button"
                    isStandalone
                    style={{ marginBottom: 0 }}
                >
                    Client Button
                </VyneRadio>
            </div>
        </div>
    )
}

export default WidgetButtonStyle
